// extracted by mini-css-extract-plugin
export var card = "_97-1";
export var container = "_97-0";